import styled from 'styled-components/macro';
import { colors as Colors } from 'constants/colors';
import { media } from 'style/media';
import { FlexContainer } from 'components/flex';

export const CollapsibleDoubleBlockContainer = styled(FlexContainer)`
    ${media.desktop`
    border-bottom: ${props => !props.lastOne && `2px solid ${Colors.SLIGHTLY_GARY}`};
    `};
`;